import * as React from 'react';
import { Props as VariantProps } from './Variant';

interface Props {
  name: string;
  variant: string;
  userIdentifier: string;
  children: React.ReactNode;
  playExperiment: (
    experimentName: string,
    variant: string,
    userIdentifier: string,
  ) => void;
}

export default class Experiment extends React.Component<Props> {
  componentDidMount() {
    const { playExperiment, name, variant, userIdentifier } = this.props;

    playExperiment(name, variant, userIdentifier);
  }

  render() {
    const { variant, children } = this.props;

    const variants = {};

    React.Children.forEach(children, element => {
      if (React.isValidElement(element)) {
        variants[(element.props as VariantProps).name] = element;
      }
    });

    return variants[variant] || null;
  }
}
